import { Easing } from 'remotion';

export const fadeEasingFunction = (t: number) => Easing.ease(t);
